import React from 'react';
import { Pagination } from '@dev/ee-components';
import { PaginationProps } from '../CustomFields';

export const PaginationComponent = (props: PaginationProps): JSX.Element => {
    const { activePage, perPage, setActivePage, setPerPage, visibleSet } = props;

    return (
        <Pagination
            id={'custom-fields-pagination'}
            activePage={activePage}
            perPage={perPage}
            dataLength={visibleSet?.length}
            handlePaginationChange={(newActivePage, newPerPage): void => {
                setActivePage(newActivePage);
                setPerPage(newPerPage);
            }}
            isRecalculatingActivePage={false}
        />
    );
};
